import { type LucideIcon, type LucideProps } from 'lucide-react';
import { forwardRef } from 'react';

/** v84 Discover nav bullseye — bespoke glyph (not Lucide Target). */
const DiscoverIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, absoluteStrokeWidth, ...props }, ref) => {
    const strokeWidth: number = typeof absoluteStrokeWidth === 'number' ? absoluteStrokeWidth : 1.5;
    return (
      <svg
        ref={ref}
        viewBox="0 0 18 18"
        fill="none"
        aria-hidden
        width={size}
        height={size}
        {...props}
      >
        <circle cx="9" cy="9" r="8" stroke="currentColor" strokeWidth={strokeWidth} />
        <circle cx="9" cy="9" r="3" fill="currentColor" />
      </svg>
    );
  }
) as LucideIcon;

export { DiscoverIcon };
